var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHandbag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 40,
    viewBox: "0 0 43 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.8992 14.7259C31.7653 13.9223 31.0699 13.3333 30.2552 13.3333H9.74564C8.93091 13.3333 8.23559 13.9223 8.10165 14.7259L5.32387 31.3926C5.15456 32.4085 5.93796 33.3333 6.96786 33.3333H33.033C34.0629 33.3333 34.8463 32.4085 34.677 31.3926",
    stroke: "#024E82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.334 13.3334C13.334 9.65152 16.3188 6.66675 20.0007 6.66675C23.6825 6.66675 26.6673 9.65152 26.6673 13.3334",
    stroke: "#024E82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.001 21.9993H31",
    stroke: "#024E82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0005 16.9987V26.9998",
    stroke: "#024E82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandbag);
export default __webpack_public_path__ + "static/media/Handbag.7a6d6f680fb49b961f9a92f81c8544e3.svg";
export { ForwardRef as ReactComponent };